export const chatFilterTypeEnum = Object.freeze({
  None: 0,
  Unread: 1,
  Starred: 2,
  All: 3,
  My: 4,
});
